import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import buildInfo from "@/buildInfo.json";

// Self-reporting build metadata — lets a deployed bundle prove what's live.
// Generated by scripts/genBuildInfo.js (npm "prebuild").
window.BUILD_COMMIT = buildInfo.commit;
window.BUILD_DATE = buildInfo.date;
// eslint-disable-next-line no-console
console.log("BUILD_COMMIT", window.BUILD_COMMIT, "BUILD_DATE", window.BUILD_DATE);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
